export function filterMatchColumns(item: any, filter: any, columns: any, columnExpressions?: any) {
  if (!filter) {
    return true;
  }
  const filterParts = filter.trim().toLowerCase().split(' ');
  return !!filterParts.filter((y: any) =>
    !!columns.filter((z: any) => {
      let data = item[z] && item[z].toString().toLowerCase();
      if (data && columnExpressions && columnExpressions[z]) {
        data = columnExpressions[z](data);
      }
      return data && data.indexOf(y) !== -1;
    }).length).length;
}
